import { Button } from 'antd';
import styled from 'styled-components';

export const Container = styled(Button)`
  margin-top: 0px;
  @media (max-width: 800px) {
    margin-top: 15px;
  }

  * {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
  }
`;
